import React, { useEffect, useState } from 'react';
import { CreateFeatureDialog } from 'components';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    menuItems,
    walletsAndGroupsStyles,
} from 'pages/wallets-and-groups/wallets-and-groups-helper';
import { WALLETS_AND_GROUPS_PATHS } from 'constants/wallets-and-groups-paths';
import { usePermission } from '../../../../core';
import { Role } from '../../../../lib';

export const CreateWalletOrGroupView = (): React.JSX.Element => {
    const [selectedOption, setSelectedOption] = useState<string>('');
    const [displayPermissionDialog, setDisplayPermissionDialog] =
        useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { hasCurrentPermissionAndRole } = usePermission();
    const queryParams = new URLSearchParams(location.search);
    const option = queryParams.get('option');

    useEffect(() => {
        if (option) {
            const selectedTab = menuItems.find(
                (item) => `${item.title}s` === option
            );
            if (selectedTab) {
                setSelectedOption(selectedTab?.navigationPath);
            }
        }
    }, [option]);

    const handleNext = (): void => {
        const selectedTab = menuItems.find(
            (item) => item.navigationPath === selectedOption
        );
        const role: Role =
            selectedTab?.title === 'User Wallet' ? 'sdzAdmin' : 'sdzGovernance';
        const permission = hasCurrentPermissionAndRole('createMetadata', role);
        if (permission && selectedOption) {
            navigate(selectedOption);
        } else if (!permission) {
            setDisplayPermissionDialog(true);
        }
    };

    const handleClose = (): void => {
        const selectedTab = menuItems.find(
            (item) => item.navigationPath === selectedOption
        );
        navigate(
            `${WALLETS_AND_GROUPS_PATHS.WALLETS_AND_GROUPS_PATH}?option=${selectedTab?.title}s`
        );
    };

    const handlePermissionDialogClose = (): void => {
        setDisplayPermissionDialog(false);
    };

    return (
        <CreateFeatureDialog
            items={menuItems}
            handleNext={handleNext}
            handleClose={handleClose}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            displayPermissionDialog={displayPermissionDialog}
            handlePermissionDialogClose={handlePermissionDialogClose}
            headingText={'What would you like to create?'}
            menuItemStyles={walletsAndGroupsStyles.menuItemStyles}
            listItemStyles={walletsAndGroupsStyles.listItemStyles}
        />
    );
};
